var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"study-psc"},[_c('psc-box-1'),_c('psc-box-2'),_c('psc-box-3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }